/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext } from "react";
import { Button, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { TI_MAP_CLUSTER_BUTTON } from "../../../Constants";

const WidgetToggleClustering = ({ style, tooltipPlacement }) => {
  const { isClusteringPoint, setIsClusteringPoint } =
    useContext(MapPropsContext);

  const onClick = useCallback(() => {
    setIsClusteringPoint((checked) => {
      return !checked;
    });
  }, []);
  // 색을 변경해달라는 요청때문에 분홍색으로 조치함
  return (
    <div style={{ ...DEFAULT_STYLE, ...style }}>
      <Tooltip
        title={isClusteringPoint ? "아이콘 보기" : "클러스터링 보기"}
        placement={tooltipPlacement}
      >
        <Button
          shape={"circle"}
          onClick={onClick}
          tabIndex={TI_MAP_CLUSTER_BUTTON}
          aria-label="클러스터링 보기"  >
          {isClusteringPoint ? (
            <FontAwesomeIcon icon={faMapMarker} color={"#F373BA"} />
          ) : (
            <FontAwesomeIcon icon={faCircleNotch} color={"#F373BA"} />
          )}
        </Button>
      </Tooltip>
    </div>
  );
};

const DEFAULT_STYLE = {};

export default WidgetToggleClustering;
